import React, { useContext } from 'react'

import { ThemeContext } from '../../contexts'
import { NavLink } from 'react-router-dom'
import ViewCountry from '../../components/ViewCountry'
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from 'react-icons/io'

import './style.css'

const Country = (props: any) => {
  const { theme } = useContext(ThemeContext)
  const id = props.match.params.id

  const slider = {
    index: '',
    prev: '',
    next: '',
  }

  const filteredCountry = props.countries.find((country: any, index: any) => {
    slider.index = index
    slider.prev = index === 0 ? '' : props.countries[index - 1].name.common
    slider.next =
      index === props.countries.length - 1
        ? ''
        : props.countries[index + 1].name.common

    return country.name.common === id
  })
  return (
    <div
      className="view-country__container"
      style={{ backgroundColor: theme.buttonColor }}
    >
      <div className="prev">
        {slider.prev !== '' ? (
          <NavLink to={slider.prev}>
            <IoIosArrowDropleftCircle />
          </NavLink>
        ) : (
          ''
        )}
      </div>
      <ViewCountry
        flag={filteredCountry.flags.png}
        name={filteredCountry.name.common}
        capital={filteredCountry.capital}
        area={filteredCountry.capital}
        population={filteredCountry.population}
        languages={filteredCountry.languages}
        currencies={filteredCountry.currencies}
        region={filteredCountry.region}
        maps={filteredCountry.maps}
      />
      <div className="next">
        {slider.next !== '' ? (
          <NavLink to={slider.next}>
            <IoIosArrowDroprightCircle />
          </NavLink>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default Country
